import { regex } from './common'
export default regex('integer', /^-?[0-9]*$/)



// WEBPACK FOOTER //
// ./src/assets/validity/validators/integer.js